<template>
    <div class="activity-item loading" :class="{small: size === 'small'}">
        <div v-if="size !== 'small'" class="activity-item-inner" >
            <span class="loading-image"></span>
            <div class="activity-item-header"></div>
            <div class="activity-item-content"></div>
        </div>
        <template v-else>
            <span class="loading-image"></span>
            <div class="activity-item-header"></div>
            <div class="activity-item-content"></div>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            size: String,
        },
    }
</script>


<style lang="scss" scoped>
$grey: rgba(#E5C89A, 40%);

.loading {
    height: 85px;

    &.small { 
        padding: 14px 0;
        height: 58px; 
        padding-left: 38px;
        background-image: none;
    }
}

.loading-image {
    position: absolute; 
    top: 0;
    left: 0;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-image: radial-gradient(
        circle calc(60px / 2), 
        $grey 99%, 
        transparent 0);

    .small & {
        height: 30px;
        width: 30px;
        top: 14px;
    }   
}

.activity-item-header {
    height: 15px;
    background-image: linear-gradient($grey 32px, transparent 0);
    
    .small & { height: 13px; }
}

.activity-item-content {
    height: 45px;
    background-image: linear-gradient($grey 32px, transparent 0);

    .small & { height: 13px; margin-top: 5px; }
}



</style>